import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Input,
    FormGroup,
    Col
} from 'reactstrap';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import './AdditionalTitle.css';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import Select from '../../commonComponents/customSelect/CustomSelect.container';

class AdditionalTitle extends Component {
    render() {
        return (
            <FormGroup className="additional-title-form-group" row key={'title-' + this.props.id}>
                <Col sm={3}>
                    <Select
                        id={'select-' + this.props.id}
                        options={this.getLangOptions()}
                        onSelect={this.handleChange}
                        selectedOption={this.getSelectedOption()}
                        placeholder={_.get(this.props.translation, 'accreditation.language_input_placeholder')}
                        requiredFieldError={this.props.requiredFieldError}/>
                </Col>
                <Col sm={8}>
                    <Input type="text"
                        className={this.props.inputClassName}
                        id={this.props.inputId}
                        value={this.props.title}
                        onChange={this.props.onChangeTitle(this.props.id)}
                        placeholder="Title translation"
                        onClick={this.props.inputOnClick}
                        required={this.props.required}
                        autoComplete={this.props.autoComplete}
                    />
                </Col>
                <Col sm={1} className="delete-title-icon-container">
                    <IconContainer
                        className="delete-title-icon"
                        icon="clear"
                        onClick={this.props.onRemove(this.props.id)}
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                    />
                </Col>
            </FormGroup>
        );
    }

    getLangOptions = () =>  {
        return this.props.langs.map(option => ({value: option, label: _.get(this.props.translation, 'langs.' + option)}));
    };

    getSelectedOption = () => {
        if(this.props.lang === '') {
            return undefined
        }
        return {
            value: this.props.lang,
            label:  _.get(this.props.translation, 'langs.' + this.props.lang)
        }
    };

    handleChange = (selectedOption) => {
        this.props.onChangeLang(this.props.id, selectedOption.value);
    };
}

AdditionalTitle.propTypes = {
    inputId: PropTypes.string,
    inputOnClick: PropTypes.func,
    inputClassName: PropTypes.string,
    id: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    langs: PropTypes.array.isRequired,
    required: PropTypes.bool,
    autoComplete: PropTypes.string,
    translation: PropTypes.object.isRequired,
    requiredFieldError: PropTypes.bool,
    onChangeLang: PropTypes.func.isRequired,
    onChangeTitle: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
};

export default AdditionalTitle;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/additionalTitle/AdditionalTitle.js